import { useParams } from 'react-router-dom'
import { PageChrome, ComingSoon, type NavKey } from '@/components/gg/chrome'

/** Screens Brian lists as "soon" (desktop-nav.js More, soon.html). */
const SOON: Record<string, { title: string; what: string; navKey?: NavKey }> = {
  seeds: { title: 'Seed bank', what: 'Buying seeds. Purchased seeds never expire; weekly seeds reset Monday.', navKey: 'seeds' },
  'past-issues': { title: 'Past issues', what: 'Every issue you’ve sent, with its opens and clicks once your email service reports them, and the sponsors who ran in it.', navKey: 'newsletter.past' },
}

/** /app/soon/:what */
export function ComingSoonPage() {
  const { what = '' } = useParams()
  const s = SOON[what] ?? { title: 'Coming soon', what: 'This part of GoGrov is designed and on its way.' }
  return (
    <>
      <PageChrome title={s.title} navKey={s.navKey} back />
      <ComingSoon title={s.title} what={s.what} />
    </>
  )
}
